import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { getGeozonesAction } from "../actions/get-geozones.action";
import { GeozonesState } from "domain/geozones/entities/interfaces/geozones-state.interface";

const getGeozonesCases = (builder: ActionReducerMapBuilder<GeozonesState>) => {
  builder.addCase(getGeozonesAction.pending, (state) => {
    state.isLoadingGeozones = true;
  });
  builder.addCase(getGeozonesAction.fulfilled, (state, action) => {
    state.geozones = action.payload;
    state.isLoadingGeozones = false;
  });
  builder.addCase(getGeozonesAction.rejected, (state) => {
    state.isLoadingGeozones = false;
  });
};

export default getGeozonesCases;
